import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  private url = environment.url;

  constructor(private http: HttpClient) { }

  getAllClienteEncargados(id: any) {
    return this.http.get(`/clienteEncargados/data/getListByCliente/${id}`);
  }
}
